import { IconCheck } from '@tabler/icons-react'

import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { cn } from '@/utils'

interface TreeNodeProps {
  icon: React.ReactNode
  label: string
  checked: boolean
  disabled?: boolean
  onCheck: (checked: boolean) => void
  onClick: () => void
  className?: string
  type: 'branch' | 'date'
  branchOnly?: boolean
}

const TreeNode = ({
  icon,
  label,
  checked,
  disabled = false,
  onCheck,
  onClick,
  className = '',
  type,
  branchOnly = false,
}: TreeNodeProps) => {
  if (type === 'date') {
    return (
      <div className="flex items-center">
        {icon ? (
          <Button
            variant="ghost"
            size="sm"
            className="h-8 w-8 p-0 mr-1"
            disabled={disabled}
            onClick={onClick}
          >
            {icon}
          </Button>
        ) : (
          // Small spacer when no icon for better visual separation
          <div className="w-2 flex-shrink-0" />
        )}
        <div className={`h-8 p-0 flex items-center flex-1 ${className}`}>
          <Checkbox
            checked={checked}
            disabled={disabled || branchOnly}
            onCheckedChange={(checked) => onCheck(checked as boolean)}
            className="text-blue-600"
          />
          <span className={`ml-2 ${disabled ? 'text-gray-400' : ''}`}>
            {label}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className="flex items-center space-x-2">
      {icon && (
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
          disabled={disabled}
          onClick={onClick}
        >
          {icon}
        </Button>
      )}
      <div
        className={cn(
          'flex h-10 items-center flex-1 relative cursor-pointer select-none rounded-sm py-1.5 pl-2 pr-7 text-sm outline-none hover:bg-accent hover:text-accent-foreground',
          disabled && 'pointer-events-none opacity-50',
          className
        )}
        onClick={() => !disabled && onCheck(!checked)}
      >
        <span
          className={
            disabled ? 'text-gray-400' : checked ? 'text-blue-600' : ''
          }
        >
          {label}
        </span>
        <span className="absolute right-2 flex h-5 w-5 items-center justify-center">
          {checked && <IconCheck className="text-blue-600" />}
        </span>
      </div>
    </div>
  )
}

export default TreeNode
